import Config from './Models/Config';
import jQuery from 'jquery';
import JSONP from './Models/JSONP';
import Layout from './Components/Layout.svelte';
import Popup from './Components/Popup.svelte';
import SwipeListener from 'swipe-listener';

window.$ = window.jQuery = jQuery;
window.JSONP = JSONP;
window.SwipeListener = SwipeListener;

const info = new RegExp('^/popup$', 'i');
const path = decodeURI(window.location.pathname);
const popup = info.test(path);

const target = document.getElementById('app');
const handler = popup ? new Popup({target}) : new Layout({target});
export default handler;